import { Calendar, TrendingUp } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ClubMonthlySummary } from '@/utils/clubMonthlySummary';

const ClubMonthlySummaryHeader = ({
	titleClassName,
}: {
	titleClassName?: string;
}) => (
	<div className="flex items-center justify-between">
		<div className="space-y-1">
			<h2
				className={cn(
					'text-xl font-bold text-slate-900',
					titleClassName,
				)}
			>
				Resumo do Mês
			</h2>
			<p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">
				Visão geral da sua atividade
			</p>
		</div>
		<div className="flex items-center gap-1.5 rounded-full border border-slate-100 bg-slate-50 px-3 py-1.5 text-[9px] font-bold uppercase tracking-widest text-slate-400">
			Uso Responsável
		</div>
	</div>
);

type ClubMonthlySummaryCardProps = {
	summary: ClubMonthlySummary;
	className?: string;
	hideHeader?: boolean;
};

const ClubMonthlySummaryCard = ({
	summary,
	className,
	hideHeader = false,
}: ClubMonthlySummaryCardProps) => {
	const {
		globalUsed,
		globalTotal,
		globalConsumptionLabel,
		globalConsumptionProgress,
		globalHasUsageCredit,
		startDate,
	} = summary;

	return (
		<div
			className={cn(
				'flex flex-col justify-between rounded-[32px] border border-slate-100 bg-white p-8 shadow-sm',
				className,
			)}
		>
			<div className="space-y-6">
				{!hideHeader && <ClubMonthlySummaryHeader />}

				<div className="flex items-end justify-between">
					<div className="flex items-center gap-4">
						<div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-orange/10 text-brand-orange">
							<TrendingUp size={24} />
						</div>
						<div>
							<div
								className={cn(
									'text-3xl font-bold',
									globalConsumptionLabel < 0
										? 'text-emerald-700'
										: 'text-slate-900',
								)}
							>
								{globalConsumptionLabel}%
							</div>
							<div className="text-[10px] font-bold uppercase tracking-widest text-slate-400">
								Consumo Total
							</div>
							{globalHasUsageCredit ? (
								<div className="mt-1 text-[9px] font-bold uppercase tracking-wider text-emerald-700">
									Crédito de uso disponível
								</div>
							) : null}
						</div>
					</div>
					<div className="text-right text-[10px] font-bold uppercase tracking-widest text-slate-900">
						<div>
							Utilizado: {globalUsed} / {globalTotal}
						</div>
						{globalHasUsageCredit ? (
							<div className="mt-1 text-[9px] font-bold uppercase tracking-wider text-emerald-700">
								Uso abaixo do registrado
							</div>
						) : null}
					</div>
				</div>

				<div className="h-2 w-full overflow-hidden rounded-full bg-slate-100">
					<div
						className="h-full bg-brand-orange transition-all duration-1000"
						style={{ width: `${globalConsumptionProgress}%` }}
					/>
				</div>
			</div>

			<div className="mt-8 flex items-center gap-3 rounded-2xl bg-slate-50 p-4 text-sm text-slate-500">
				<Calendar size={16} className="text-brand-orange" />
				<span>Assinatura iniciada em {startDate}.</span>
			</div>
		</div>
	);
};

export { ClubMonthlySummaryCard, ClubMonthlySummaryHeader };
